import React from 'react';
import { Trophy, Calendar, MapPin, Award } from 'lucide-react';
import Footer from '../components/Footer';

const Hackathons = () => {
  const hackathons = [
    {
      name: 'GameOfTech OpenApi organisée par Bouygues Telecom #1',
      company: 'Bouygues Telecom',
      date: '2023',
      location: 'Paris, France',
      description: 'Le but était d\'utiliser les nouvelles hashtags API de Bouygues Telecom et de proposer une solution innovante en les utilisant.',
      achievement: 'Création d\'un chatbot utilisant les nouvelles hashtags API de Bouygues Telecom',
      technologies: ['API', 'Bouygues Telecom', 'Chatbot', 'Python'],
      award: null
    },
    {
      name: 'Starton Hackathon',
      company: 'Starton, Ledger, Binance',
      date: '2023',
      location: 'Paris, France',
      description: 'Développement de Vot\'Chain, Un concept qui pourrait révolutionner l\'expérience du droit de vote. Impacter l\'expérience des citoyens et des candidats grâce au vote en ligne sur la hashtag#blockchain grâce aux smart-contract et aux api Starton !',
      achievement: 'Développement d\'une plateforme de vote en ligne',
      technologies: ['Blockchain', 'Web3', 'Smart Contracts', 'React', 'TypeScript', 'Solidity'],
      award: null
    },
    {
      name: 'Starton Hackathon',
      company: 'Starton, Groupe M6, Ledger, BNB, RTL, 20 Minutes France',
      date: '2023',
      location: 'Paris, France',
      description: 'Permettre aux journalistes de publier des articles totalement incensurables et accessibles au monde entier grâce à IPFS. Un accès gratuit accessible à tous, et des prix fixés par l\'auteur lui-même sur une crypto monnaie créée pour ce hackathon.',
      achievement: 'Développement d\'un site web permettant de publier des articles totalement incensurables et accessibles au monde entier grâce à IPFS.',
      technologies: ['NFT', 'DeFi', 'IPFS', 'Solidity', 'React', 'TypeScript'],
      award: null
    },
    {
      name: 'Crédit Agricole FinTech Hackathon',
      company: 'Crédit Agricole',
      date: '2023',
      location: 'Paris, France',
      description: 'Hackathon de technologie financière centré sur la banque numérique, les solutions de paiement et l\'analyse de données financières.',
      achievement: 'Développement d\'un tableau de bord d\'analyse bancaire',
      technologies: ['FinTech', 'APIs', 'Analyse de Données', 'TypeScript'],
      award: null
    }
  ];

  return (
    <div className="space-y-10">
      <div>
        <h1 className="text-5xl font-bold mb-6 text-gray-900 dark:text-gray-100">
          Hackathons
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400">
          Défis d'innovation et participations aux hackathons avec des entreprises de premier plan.
        </p>
      </div>

      <div className="space-y-8">
        {hackathons.map((hackathon, index) => (
          <article
            key={index}
            className="group border-l-2 border-transparent hover:border-gray-400 dark:hover:border-gray-600 pl-4 py-2 transition-all"
          >
            <div className="flex items-start justify-between mb-3">
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 group-hover:text-gray-600 dark:group-hover:text-gray-400 transition-colors flex items-center gap-2">
                  <Trophy size={24} className="text-yellow-500" />
                  {hackathon.name}
                </h2>
                <div className="flex flex-wrap items-center gap-4 mt-2 text-sm text-gray-600 dark:text-gray-400">
                  <span className="font-medium text-lg">{hackathon.company}</span>
                  <span className="flex items-center gap-1">
                    <Calendar size={14} />
                    {hackathon.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <MapPin size={14} />
                    {hackathon.location}
                  </span>
                </div>
              </div>
              {hackathon.award && (
                <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400">
                  <Award size={16} />
                  <span className="text-sm font-medium">{hackathon.award}</span>
                </div>
              )}
            </div>

            <p className="text-gray-600 dark:text-gray-400 mb-3 leading-relaxed">
              {hackathon.description}
            </p>

            <div className="mb-3">
              <p className="text-sm text-gray-700 dark:text-gray-300">
                <span className="font-semibold">✨ Réalisation :</span> {hackathon.achievement}
              </p>
            </div>

            <div className="flex flex-wrap gap-2">
              {hackathon.technologies.map((tech, techIndex) => (
                <span
                  key={techIndex}
                  className="px-2 py-1 text-xs rounded bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400"
                >
                  {tech}
                </span>
              ))}
            </div>
          </article>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default Hackathons;